export default __webpack_public_path__ + "static/media/mute.70baa7fe.svg";